import { AssignmentBlockOutputCreateModel } from '@models/assignments';
import { create } from 'zustand';

export interface EnrichedBlockOutput extends AssignmentBlockOutputCreateModel {
  idempotencyKey: string;
  nodeEntityId: string;
  goalSubscriptionId: number;
}

interface BlockOutputsStore {
  blockOutputs: EnrichedBlockOutput[];
  // The POST that currently carries drained logs — shared, because whoever drains takes everyone's.
  inFlightFlush: Promise<void> | null;
  setBlockOutputs: (blockOutputs: EnrichedBlockOutput[]) => void;
  appendBlockOutputs: (blockOutputs: EnrichedBlockOutput[]) => void;
  drainBlockOutputs: () => EnrichedBlockOutput[];
  setInFlightFlush: (inFlightFlush: Promise<void> | null) => void;
}

export const useBlockOutputsStore = create<BlockOutputsStore>((set, get) => ({
  blockOutputs: [],
  inFlightFlush: null,
  setBlockOutputs: (blockOutputs) => set({ blockOutputs: blockOutputs }),
  appendBlockOutputs: (blockOutputs) =>
    // filter out logs with the same idempotencyKey
    set((state) => ({
      blockOutputs: [
        ...state.blockOutputs,
        ...blockOutputs.filter(
          (blockOutput) =>
            !state.blockOutputs.some((l) => l.idempotencyKey === blockOutput.idempotencyKey)
        )
      ]
    })),
  drainBlockOutputs: (): EnrichedBlockOutput[] => {
    const blockOutputs = get().blockOutputs;
    set({ blockOutputs: [] });
    return blockOutputs;
  },
  setInFlightFlush: (inFlightFlush) => set({ inFlightFlush })
}));
